import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { responseTypes } from "utils/Types";
import { axiosGet, axiosPost } from "../../../utils/APIHelper";
import { PlanDetailState } from "./PlanDetail";

const initialState: PlanDetailState = {
  planDetails: [],
  isBookmarked: false,
  status: "idle",
  commentList: [],
  planDetailShowLoader: false,
  commentShowLoader: false,
  copySectionData: {
    copySectionType: false,
    dialogTitle: "",
    sectionPayload: []
  }
};

export const fetchPlanDetailAsync = createAsyncThunk("planDetails", async (data: any, thunkApi) => {
  const { rejectWithValue } = thunkApi;
  const { planId, innCode, innCodes } = data;
  const API_URL = innCodes
    ? `plans/${planId}?innCode=${innCode}&otherInnCodes=${innCodes}`
    : `plans/${planId}?innCode=${innCode}`;
  const response: any = await axiosGet(API_URL);
  if (response.status !== responseTypes.success) {
    return rejectWithValue(response.response.data);
  }
  if (
    response?.response?.status >= responseTypes.internal_error &&
    response?.response?.status < responseTypes.other_error
  ) {
    return thunkApi.rejectWithValue(response.response);
  }
  return response.data;
});

export const createCommentAsync = createAsyncThunk("planComment", async (data: any, thunkApi) => {
  const API_URL = `plans/${data.planId}/sections/${data.sectionId}/cards/${data.cardId}/comments`;
  const payload = { commentList: [{ comments: data.comments, taggedUserIds: data.taggedUserIds }] };
  const response: any = await axiosPost(API_URL, "userplan", { ...payload });
  if (response.status === responseTypes.error) {
    return thunkApi.rejectWithValue(response.response.data);
  }
  return response.data;
});

export const fetchCommentAsync = createAsyncThunk("planGetComment", async (data: any, thunkApi) => {
  const API_URL = `plans/${data.planId}/sections/${data.sectionId}/cards/${data.cardId}/comments`;
  const response: any = await axiosGet(API_URL, "userplan");
  if (response.status === responseTypes.error) {
    return thunkApi.rejectWithValue(response.response.data);
  }
  return response.data;
});

export const PlanDetailSlice = createSlice({
  name: "plan details",
  initialState,
  reducers: {
    setisBookmarked(state, action) {
      state.isBookmarked = action.payload;
    },
    setCopySectionData(state, action) {
      state.copySectionData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlanDetailAsync.pending, (state) => {
        state.planDetailShowLoader = true;
        state.status = "loading";
      })
      .addCase(fetchPlanDetailAsync.fulfilled, (state, action: any) => {
        state.status = "idle";
        state.planDetails = action.payload;
        state.planDetailShowLoader = false;
      })
      .addCase(fetchPlanDetailAsync.rejected, (state) => {
        state.status = "failed";
        state.planDetailShowLoader = false;
      })
      .addCase(createCommentAsync.fulfilled, (state, action: any) => {
        state.status = "idle";
        state.commentList.unshift(...action.payload);
      })
      .addCase(fetchCommentAsync.pending, (state) => {
        state.status = "loading";
        state.commentShowLoader = true;
      })
      .addCase(fetchCommentAsync.fulfilled, (state, action: any) => {
        state.status = "idle";
        state.commentList = action.payload.commentList;
        state.commentShowLoader = false;
      })
      .addCase(fetchCommentAsync.rejected, (state, action: any) => {
        state.status = "failed";
        state.commentList = action.payload.commentList;
        state.commentShowLoader = false;
      })
      .addCase(createCommentAsync.rejected, (state) => {
        state.status = "failed";
      });
  }
});

export const { setisBookmarked, setCopySectionData } = PlanDetailSlice.actions;

export default PlanDetailSlice.reducer;
